import axios from "axios";

export const api = axios.create({
  baseURL: process.env.GATSBY_API_URL,
});

export const viaCepApi = axios.create({
  baseURL: process.env.GATSBY_VIACEP_API_URL,
});

export const pagarmeApi = axios.create({
  baseURL: process.env.GATSBY_PAGARME_API_BASE_URL,
});
